import React from 'react';
import { Box, CircularProgress, keyframes } from '@mui/material';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
    border-top-color: #FF4500;
    border-right-color: #FFA500;
  }
  25% {
    border-top-color: #FF6347;
    border-right-color: #FFD700;
  }
  50% {
    border-top-color: #FF8C00;
    border-right-color: #FFA500;
  }
  75% {
    border-top-color: #FFA500;
    border-right-color: #FFD700;
  }
  100% {
    transform: rotate(360deg);
    border-top-color: #FF4500;
    border-right-color: #FFA500;
  }
`;

const Loader = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                backgroundColor: 'transparent'
            }}
        >
            <Box
                sx={{
                    zIndex: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 80,
                    height: 80,
                    position: 'relative',
                    animation: `${pulse} 2s infinite`
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        border: '6px solid transparent',
                        animation: `${spinAnimation} 1.5s linear infinite`
                    }}
                />

                <CircularProgress
                    thickness={6}
                    size={60}
                    sx={{
                        position: 'absolute',
                        zIndex: 3,
                        animation: `${spinAnimation} 1.5s linear infinite`,
                        '& .MuiCircularProgress-circle': {
                            stroke: 'url(#gradient)'
                        }
                    }}
                />
                
                <svg width="0" height="0">
                    <defs>
                        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#FF4500" />
                            <stop offset="50%" stopColor="#FF8C00" />
                            <stop offset="100%" stopColor="#FFD700" />
                        </linearGradient>
                    </defs>
                </svg>
            </Box>
        </Box>
    );
};

export default Loader;